// Import the functions you need from the SDKs you need
import { getApp, getApps, initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth"; // For authentication
import { getFirestore } from "firebase/firestore"; // For Firestore database
import { getStorage } from "firebase/storage"; // For Storage
import { getMessaging } from "firebase/messaging";
import { getFunctions } from "firebase/functions";

// Your web live app's Firebase configuration

const firebaseConfig = {
  apiKey: "AIzaSyDo_FqutSqnAdeLAgff4ggRcWX0pg2h5XM",
  authDomain: "team-edelstein.firebaseapp.com",
  projectId: "team-edelstein",
  storageBucket: "team-edelstein.firebasestorage.app",
  messagingSenderId: "627842934381",
  appId: "1:627842934381:web:1262ee1777d45c7cb6c164",
};

// const firebaseConfig = {
//   apiKey: "AIzaSyBGb4fcrb7VFRYXDiPKAETSa6ueGcw4qH8",
//   authDomain: "team-henry-demo.firebaseapp.com",
//   projectId: "team-henry-demo",
//   storageBucket: "team-henry-demo.firebasestorage.app",
//   messagingSenderId: "475392448682",
//   appId: "1:475392448682:web:6b2821dc598ac12d77d8d3",
//   measurementId: "G-WZQB28ZFLC",
// };

// Initialize Firebase
const app = getApps().length > 0 ? getApp() : initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const messaging = getMessaging();

// Initialize Firebase Services
const auth = getAuth(app);
const firestored = getFirestore(app);
const storage = getStorage(app);
const functionsClient = getFunctions(app, "us-central1");

export { app, analytics, auth, firestored, storage, messaging, functionsClient, firebaseConfig };
